import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetReasonsInputDto, ReasonCreateDto, ReasonDto, ReasonExcelDownloadDto, ReasonUpdateDto } from '../dtos/reason/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ReasonService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: ReasonCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonDto>({
      method: 'POST',
      url: '/api/general/reasons',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/reasons/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/reasons',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonDto>({
      method: 'GET',
      url: `/api/general/reasons/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/reasons/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetReasonsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ReasonDto>>({
      method: 'GET',
      url: '/api/general/reasons',
      params: { name: input.name, code: input.code, reasonGroupId: input.reasonGroupId, reasonGroupName: input.reasonGroupName, reasonGroupBiId: input.reasonGroupBiId, reasonGroupBiName: input.reasonGroupBiName, isVisible: input.isVisible, isProductive: input.isProductive, isForDisableResourceTemporarily: input.isForDisableResourceTemporarily, isEnabledForLiquidation: input.isEnabledForLiquidation, canDeprocessHarvestActivityReport: input.canDeprocessHarvestActivityReport, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ReasonExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/reasons/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, reasonGroupId: input.reasonGroupId, reasonGroupName: input.reasonGroupName, reasonGroupBiId: input.reasonGroupBiId, reasonGroupBiName: input.reasonGroupBiName, isVisible: input.isVisible, isProductive: input.isProductive, isForDisableResourceTemporarily: input.isForDisableResourceTemporarily, isEnabledForLiquidation: input.isEnabledForLiquidation, canDeprocessHarvestActivityReport: input.canDeprocessHarvestActivityReport, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonDto[]>({
      method: 'GET',
      url: '/api/general/reasons/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ReasonUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReasonDto>({
      method: 'PUT',
      url: `/api/general/reasons/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}